module.exports = __webpack_public_path__ + "static/media/Atharva_Sardesai_2.b5ce4e9c.jpeg";